"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryCatch = tryCatch;
exports.tryCatchAsync = tryCatchAsync;
function tryCatch(fn) {
    try {
        return [fn(), null];
    }
    catch (error) {
        return [null, error instanceof Error ? error : new Error(String(error))];
    }
}
function tryCatchAsync(fn) {
    return fn()
        .then((result) => [result, null])
        .catch((error) => [null, error instanceof Error ? error : new Error(String(error))]);
}
//# sourceMappingURL=try-catch.js.map